let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hV9Rr")).then(() => parcelRequire('3Nmej'));